import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";
import TaskProgramFormGridPluginSettings from "./TaskProgramFormGridPluginSettings";
import TaskProgramFormGrid from "./TaskProgramFormGrid";

const TaskProgramFormSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const gridId = uuidv4();
    const plugin = TaskProgramFormGridPluginSettings;
    const { t } = useTranslation();

    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntity ?? []);

    return <GridSelectorModalWindow gridDisplayName={plugin?.name ?? t('directory.taskProgram.title')}
        entityToPressEnter={entity}
        ok={{
            onClick: () => props.ok?.(entity)
        }}
        cancel={{
            onClick: () => props.cancel?.()
        }} >
        {
            <TaskProgramFormGrid
                gridId={gridId}
                plugin={plugin}
                data={entities}
                multipleSelect={props.multipleSelect}
                onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
                onDoubleClick={(row) => {
                    setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                    props.ok?.(entity)
                }}
                onMultipleSelect={(rows) => {
                    rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                }}
            />
        }
    </GridSelectorModalWindow>
}

export default TaskProgramFormSelectorModal